import Component from '@glimmer/component';

interface SpaceCardSignature {
  Args: {
    hasHoverEffect?: boolean;
    variant?: 'v1' | 'v2' | 'v3';
    title?: string;
    titleClass?: string;
    titlePosition?: 'left' | 'right';
  };
  Blocks: {
    default: [];
  };
}

export default class SpaceCard extends Component<SpaceCardSignature> {
  get cardClass() {
    const variant = this.args.variant || 'v1';
    return `space-card space-card--${variant} h-full`;
  }

  get containerClass() {
    return this.args.hasHoverEffect ? 'space-card-hover-effect' : '';
  }

  get titleClass() {
    return (
      'sci-card__title' +
      (this.args.titleClass ? ` ${this.args.titleClass}` : '')
    );
  }

  get titlePositionClass() {
    const position = this.args.titlePosition || 'center';
    return position === 'left'
      ? 'left-20'
      : position === 'right'
        ? 'right-20'
        : 'left-1/2 transform -translate-x-1/2';
  }

  get setMarginTop() {
    return this.args.title ? 'mt-1 md:mt-3' : '';
  }

  get bodyClass() {
    return this.args.bodyClass ? this.args.bodyClass : '';
  }

  <template>
    <div class="{{this.containerClass}} sci-card-first-container relative w-full">
      {{#if @title}}
        <div
          class="absolute z-20 sci-card-title-container
            {{@variant}}
            {{this.titlePositionClass}}"
        >
          <div class="sci-card-title-bg">
            <h3 class="{{this.titleClass}}">{{@title}}</h3>
          </div>
        </div>
      {{/if}}
      <div class="h-full sci-card-second-container w-full">
        <div class={{this.cardClass}}>
          <div class="sci-card bg-white/5 h-full w-full">
            <div
              class="sci-card-body {{this.bodyClass}} {{this.setMarginTop}}"
              ...attributes
            >
              {{yield}}
            </div>
          </div>
        </div>
      </div>
      {{#if (has-block "footer")}}
        <div class="sci-card__footer absolute z-20">
          <div class="sci-card__footer-content">
            {{yield to="footer"}}
          </div>
        </div>
      {{/if}}
    </div>
  </template>
}
